var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DoneAll as DoneAllIcon } from '@mui/icons-material';
import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography } from '@mui/material';
import { useSnackbar } from 'notistack';
import { useState } from 'react';
import { concluirAnaliseFunac } from '../fila_analise_funac_service';
var MAX_CHARS = 200;
export function ModalConcluirAnaliseFunac(_a) {
    var _this = this;
    var open = _a.open, onClose = _a.onClose, folhaId = _a.folhaId, onSucesso = _a.onSucesso;
    var enqueueSnackbar = useSnackbar().enqueueSnackbar;
    var _b = useState(''), observacao = _b[0], setObservacao = _b[1];
    var _c = useState(false), loading = _c[0], setLoading = _c[1];
    var handleClose = function () {
        setObservacao('');
        setLoading(false);
        onClose();
    };
    var handleConfirmar = function () { return __awaiter(_this, void 0, void 0, function () {
        var resp, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!folhaId)
                        return [2 /*return*/];
                    setLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, concluirAnaliseFunac(folhaId, observacao || undefined)];
                case 2:
                    resp = _a.sent();
                    enqueueSnackbar(resp.mensagem || 'Análise concluída. Folha ANALISADA com sucesso.', {
                        variant: 'success',
                        anchorOrigin: { vertical: 'top', horizontal: 'right' },
                    });
                    setObservacao('');
                    onSucesso(folhaId, resp);
                    onClose();
                    return [3 /*break*/, 5];
                case 3:
                    e_1 = _a.sent();
                    console.error('Erro ao concluir análise:', e_1);
                    enqueueSnackbar('Erro ao concluir análise. Verifique sua conexão e tente novamente.', {
                        variant: 'error',
                        anchorOrigin: { vertical: 'top', horizontal: 'right' },
                    });
                    return [3 /*break*/, 5];
                case 4:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs(Dialog, __assign({ open: open, onClose: undefined, fullWidth: true, maxWidth: 'sm', PaperProps: { sx: { borderRadius: 3, overflow: 'hidden' } } }, { children: [_jsx(DialogTitle, __assign({ sx: { pb: 1, borderBottom: '1px solid #e5e7eb' } }, { children: _jsx(Typography, __assign({ variant: 'h6', sx: { fontWeight: 800, color: '#16a34a', fontSize: '1.1rem' } }, { children: "Concluir An\u00E1lise" })) })), _jsxs(DialogContent, __assign({ sx: { px: 3, py: 2.5 } }, { children: [_jsx(Typography, __assign({ variant: 'body2', sx: { color: '#374151', fontSize: '0.88rem', mb: 2.5, lineHeight: 1.6 } }, { children: "Confirme que esta folha est\u00E1 correta e regular. Esta a\u00E7\u00E3o \u00E9 definitiva para o m\u00EAs selecionado." })), _jsx(Typography, __assign({ variant: 'overline', sx: { display: 'block', color: '#6b7280', fontWeight: 700, letterSpacing: '0.06em', fontSize: '0.68rem', mb: 0.5 } }, { children: "OBSERVA\u00C7\u00C3O" })), _jsx(TextField, { id: 'campo-observacao-concluir', multiline: true, minRows: 3, maxRows: 5, fullWidth: true, placeholder: 'Informe uma observa\u00E7\u00E3o sobre a an\u00E1lise...', value: observacao, onChange: function (e) { return setObservacao(e.target.value.slice(0, MAX_CHARS)); }, sx: {
                            backgroundColor: '#fff',
                            '& .MuiOutlinedInput-root': {
                                borderRadius: 2,
                                '& fieldset': { borderColor: '#d1d5db' },
                                '&:hover fieldset': { borderColor: '#9ca3af' },
                                '&.Mui-focused fieldset': { borderColor: '#16a34a' },
                            },
                        } }), _jsxs(Typography, __assign({ variant: 'caption', sx: { display: 'block', textAlign: 'right', mt: 0.5, color: observacao.length >= MAX_CHARS ? '#dc2626' : '#9ca3af', fontSize: '0.72rem' } }, { children: [observacao.length, "/", MAX_CHARS] }))] })), _jsxs(DialogActions, __assign({ sx: { px: 3, py: 2, borderTop: '1px solid #e5e7eb', justifyContent: 'flex-end', gap: 1 } }, { children: [_jsx(Button, __assign({ id: 'btn-cancelar-concluir', variant: 'outlined', onClick: handleClose, disabled: loading, sx: {
                            fontWeight: 700,
                            color: '#4b5563',
                            borderColor: '#d1d5db',
                            borderRadius: 2,
                            px: 3,
                            backgroundColor: '#fff',
                            textTransform: 'none',
                            '&:hover': { backgroundColor: '#f3f4f6', borderColor: '#d1d5db' },
                        } }, { children: "CANCELAR" })), _jsx(Button, __assign({ id: 'btn-confirmar-concluir', variant: 'contained', onClick: handleConfirmar, disabled: loading, startIcon: loading ? _jsx(CircularProgress, { size: 16, color: 'inherit' }) : _jsx(DoneAllIcon, {}), sx: {
                            fontWeight: 700,
                            textTransform: 'none',
                            backgroundColor: '#16a34a',
                            color: 'white',
                            borderRadius: 2,
                            px: 3,
                            '&:hover': { backgroundColor: '#15803d' },
                            '&.Mui-disabled': { backgroundColor: '#86efac', color: '#fff' },
                        } }, { children: loading ? 'CONCLUINDO...' : 'CONCLUIR ANÁLISE' }))] }))] })));
}
